import React from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell,
    LineChart,
    Line,
    AreaChart,
    Area
} from 'recharts';

const PredictiveCharts = ({ hourly, weekly }) => {
    
    // Gradiente para horas
    const getHourColor = (count, max) => {
        const ratio = count / max;
        if (ratio > 0.8) return '#dc3545'; // Rojo
        if (ratio > 0.5) return '#fd7e14'; // Naranja
        return '#007bff'; // Azul
    };

    const maxHourly = Math.max(...hourly.map(h => h.count), 1);
    const maxWeekly = Math.max(...weekly.map(w => w.count), 1);

    const CustomTooltip = ({ active, payload, label, suffix }) => {
        if (active && payload && payload.length) {
            return (
                <div className="bg-white p-3 border rounded shadow-sm">
                    <p className="mb-1 font-weight-bold">{label}{suffix}</p>
                    <p className="mb-0 text-primary">Frecuencia: {payload[0].value}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="row">
            {/* HOURLY TREND */}
            <div className="col-md-7 mb-4">
                <h6 className="text-muted mb-3 font-weight-bold">Distribución por Hora del Día (24h)</h6>
                <div style={{ width: '100%', height: '300px' }}>
                    <ResponsiveContainer>
                        <AreaChart data={hourly}>
                            <defs>
                                <linearGradient id="colorCount" x1="0" y1="0" x2="0" y2="1">
                                    <stop offset="5%" stopColor="#007bff" stopOpacity={0.8}/>
                                    <stop offset="95%" stopColor="#007bff" stopOpacity={0}/>
                                </linearGradient>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
                            <XAxis dataKey="hour" tickFormatter={(h) => `${h}h`} stroke="#888" fontSize={12} />
                            <YAxis stroke="#888" fontSize={12} />
                            <Tooltip content={<CustomTooltip suffix="h" />} />
                            <Area type="monotone" dataKey="count" stroke="#007bff" fillOpacity={1} fill="url(#colorCount)" />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            </div>

            {/* WEEKLY TREND */}
            <div className="col-md-5 mb-4">
                <h6 className="text-muted mb-3 font-weight-bold">Probabilidad por Día de la Semana</h6>
                <div style={{ width: '100%', height: '300px' }}>
                    <ResponsiveContainer>
                        <BarChart data={weekly} layout="vertical">
                            <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#eee" />
                            <XAxis type="number" hide />
                            <YAxis dataKey="day_name" type="category" stroke="#888" fontSize={12} width={80} />
                            <Tooltip content={<CustomTooltip suffix="" />} />
                            <Bar dataKey="count" radius={[0, 4, 4, 0]}>
                                {weekly.map((entry, index) => (
                                    <Cell 
                                        key={`cell-${index}`} 
                                        fill={entry.count / maxWeekly > 0.8 ? '#dc3545' : '#007bff'} 
                                    />
                                ))}
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
};

export default PredictiveCharts;
